import { useEffect, useRef } from 'react'
import { View } from 'react-native'
import { ResizeMode, Video } from 'expo-av'

export const DotiFooter = ({ styles, isActive }) => {
    const videoRef = useRef(null)
    const intervalRef = useRef(null)

    useEffect(() => {
        if (!isActive) {
            clearInterval(intervalRef.current)
            intervalRef.current = null
            return
        }

        intervalRef.current = setInterval(() => {
            videoRef.current?.replayAsync()
        }, 19000)

        return () => {
            clearInterval(intervalRef.current)
        }
    }, [isActive])

    return (
        <View
            style={{
                width: 60,
                height: 60,
                borderRadius: 30,
                backgroundColor: '#F1F2FF',
                borderWidth: 6,
                borderColor: 'white',
                alignItems: 'center',
                justifyContent: 'center',
                overflow: 'hidden',
                ...styles,
            }}
        >
            <Video
                ref={videoRef}
                source={require('../../../assets/doti/dotiAnimation.mp4')}
                style={{
                    width: 38,
                    height: 38,
                }}
                isLooping={false}
                shouldPlay={isActive}
                resizeMode={ResizeMode.CONTAIN}
            />
        </View>
    )
}
